import { NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { TimeAgoModule } from 'src/app/pipes/time-ago/time-ago.module';
import { ItemRatingComponent } from 'src/app/shared-components/item-rating/item-rating.component';
import {MatchLocaleModule} from '../../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'app-single-item-preview-modal',
  standalone: true,
  imports: [ItemRatingComponent, NgForOf, TimeAgoModule, RouterModule, TranslateModule, NgIf, MatchLocaleModule],
  templateUrl: './single-item-preview-modal.component.html',
})
export class SingleItemPreviewModalComponent {
  @Input() singleItem: any;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() confirmModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  PAGES_AND_PATHS = PAGES_AND_PATHS;

}
